import { buildProps, definePropType, iconPropType } from '@bigin/utils'
import type { ExtractPropTypes } from 'vue'
import type { Property } from 'csstype'
import type Avatar from './avatar.vue'

export const avatarProps = buildProps({
  size: {
    type: [Number],
    default: 40,
  },
  shape: {
    type: String,
    values: ['circle', 'square'],
    default: 'circle',
  },
  icon: {
    type: iconPropType,
  },
  src: {
    type: String,
    default: '',
  },
  alt: String,
  srcSet: String,
  fit: {
    type: definePropType<Property.ObjectFit>(String),
    default: 'cover',
  },
  name: { type: String, default: '' },
  colorId: { type: String, default: '' },
  circle: Boolean,
  gradient: Boolean,
} as const)
export type AvatarProps = ExtractPropTypes<typeof avatarProps>

export const avatarEmits = {
  error: (evt: Event) => evt instanceof Event,
}
export type AvatarEmits = typeof avatarEmits

export type AvatarInstance = InstanceType<typeof Avatar>
